(function() {

  'use strict';

  function parseAddressReceiver($filter, $sce) {
    return function(address, wordwise, htmlFormat) {

      if (address) {
        var addressFormated =
          address.cidade + ', ' +
          (address.uf ? address.uf : address.estado) + ' - ' +
          $filter('cep')(address.cep ? address.cep : address.codigoPostal) + ' - ' +
          (wordwise ? '<br />' : '') +
          address.logradouro.trim() + ', ' +
          address.numero.trim() + ', ' +
          _.get(address, 'complemento', '') +
          address.bairro;

        return htmlFormat ? $sce.trustAsHtml(addressFormated) : addressFormated;
      }

    }

  };

  angular
    .module('mandaeApp')
    .filter('parseAddressReceiver', parseAddressReceiver);

})();
